module.exports = __webpack_public_path__ + "static/media/homebackground.37c8a68f.jpg";